import { useInfiniteQuery } from "react-query";
import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { VotacaoParticipanteItem } from "../typings";
import axios from "infra/http";

function useParticipantesAssembleia(
  id: string,
  params: PaginateQuery & { prefixos: string }
) {
  return useInfiniteQuery(
    `/v1/votacao/${id}/participantes/${params.prefixos}-${params.search}-${params.limit}`,
    async ({ pageParam }) => {
      const { data } = await axios.get<PaginateResult<VotacaoParticipanteItem>>(
        `/v1/votacao/${id}/participantes`,
        {
          params: {
            ...params,
            page: pageParam ?? 1,
          },
        }
      );

      return data;
    },
    { getNextPageParam: (lastPage) => lastPage.meta.currentPage === lastPage.meta.totalPages ? undefined : lastPage.meta.currentPage + 1, }
  );
}

export default useParticipantesAssembleia;
